import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Banner.css';

const Banner = () => {
  const location = useLocation();

  // Determine current page from pathname
  const getCurrentPage = () => {
    const path = location.pathname.toLowerCase();

    if (path.includes('/discover')) return 'discover';
    if (path.includes('/guides')) return 'guides';
    if (path.includes('/editorials')) return 'editorials';
    if (path.includes('/signals')) return 'signals';
    if (path.includes('/shop')) return 'shop';

    // Default to discover for other pages
    return 'discover';
  };

  const currentPage = getCurrentPage();

  // Banner is the same image but with different cropping/positioning per page
  const bannerSrc = '/assets-branding/artifex-banner.png';

  return (
    <div className={`banner-container banner-${currentPage}`}>
      <Link to="/discover">
        <img
          src={bannerSrc}
          alt="Artifex Header"
          className={`header-banner header-banner-${currentPage}`}
        />
      </Link>
    </div>
  );
};

export default Banner;
